import React, { useState, useEffect } from 'react';
import { login } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import '../../css/Login.css';
import { useAuth } from "../../utils/auth.context";
import Logo from "../../assets/img/logo.png";

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [infoMessage, setInfoMessage] = useState('');
    const navigate = useNavigate();
    const { setUser, setIsAuthenticated, user } = useAuth();

    useEffect(() => {
        if (user?.data?.token) {
            navigate('/profile');
        }
    }, [user, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const user = await login(username, password);
            if (user.data.token) {
                setIsAuthenticated(true);
                setUser((prev) => ({ ...prev, data: user.data }))
                navigate('/');
            }
            setInfoMessage('Invalid credentials')
        } catch (error) {
            setMessage('Error: Invalid credentials');
        }
    };
    return (
        <div className="login-container">
            <div className="login-card">
                <div className="logo-and-title">
                    <span className="login-logo-frame">
                        <img width={34} height={34} src={Logo} alt="Logo"/>
                    </span>
                    <div className="login-heading">
                        <h2 className="login-title">Resource Provider</h2>
                        <p className="login-subtitle">Sign in to manage resources</p>
                    </div>
                </div>
                <form onSubmit={handleSubmit} className="login-form">
                    <label className="login-field">
                        <span>Username</span>
                        <input
                            name="username"
                            type="text"
                            placeholder="Enter username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="login-input"
                            required
                        />
                    </label>
                    <label className="login-field">
                        <span>Password</span>
                        <input
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="login-input"
                            required
                        />
                    </label>
                    <button type="submit" className="login-button">Login</button>
                </form>
                {message && <p className="login-error">{message}</p>}
                {infoMessage && <p className="login-info">{infoMessage}</p>}
            </div>
        </div>
    );
};

export default Login;
